(() => {
  document.querySelectorAll('[data-readiness-assessment]').forEach((section) => {
    const form = section.querySelector('[data-assessment-form]');
    if (!form || form.dataset.ready === 'true') return;
    form.dataset.ready = 'true';
    const questions = Array.from(form.querySelectorAll('[data-question]'));
    const next = form.querySelector('[data-next]');
    const prev = form.querySelector('[data-prev]');
    const error = form.querySelector('[data-question-error]');
    const progressText = form.querySelector('[data-progress-text]');
    const progressPercent = form.querySelector('[data-progress-percent]');
    const progressBar = form.querySelector('[data-progress-bar]');
    const results = section.querySelector('[data-results]');
    const retake = section.querySelector('[data-retake]');
    const revealAndFocus = (target) => {
      target.setAttribute('tabindex', '-1');
      target.focus({ preventScroll: true });
      target.scrollIntoView({
        behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth',
        block: 'start',
      });
    };
    let index = 0;
    const update = () => {
      questions.forEach((q, i) => { q.hidden = i !== index; });
      const percent = Math.round(((index + 1) / questions.length) * 100);
      progressText.textContent = 'Question ' + (index + 1) + ' of ' + questions.length;
      progressPercent.textContent = percent + '%';
      progressBar.style.width = percent + '%';
      prev.hidden = index === 0;
      next.textContent = index === questions.length - 1 ? 'See my result' : 'Next question';
      error.hidden = true;
    };
    const hasAnswer = () => Boolean(questions[index].querySelector('input:checked'));
    const showResult = () => {
      const answers = Array.from(form.querySelectorAll('input:checked'));
      const score = answers.reduce((sum, input) => sum + Number(input.value), 0) / questions.length;
      let stage = 'foundation';
      if (score >= 3.25) stage = 'scale'; else if (score >= 2.5) stage = 'growth'; else if (score >= 1.75) stage = 'consistency';
      results.querySelectorAll('[data-result]').forEach((panel) => { panel.hidden = panel.dataset.result !== stage; });
      form.hidden = true; results.hidden = false; revealAndFocus(results);
    };
    next.addEventListener('click', () => { if (!hasAnswer()) { error.hidden = false; return; } if (index === questions.length - 1) { showResult(); return; } index += 1; update(); });
    prev.addEventListener('click', () => { if (index > 0) { index -= 1; update(); } });
    form.addEventListener('change', () => { error.hidden = true; });
    retake.addEventListener('click', () => { form.reset(); index = 0; results.hidden = true; form.hidden = false; update(); revealAndFocus(form); });
    update();
  });
})();